"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('round-mask', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 44C32.9553 44 40.5359 38.1142 43.0844 30H4.9156C7.46413 38.1142 15.0447 44 24 44Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M4.9156 30C7.46413 38.1142 15.0447 44 24 44C32.9553 44 40.5359 38.1142 43.0844 30M4.9156 30C4.32071 28.1059 4 26.0904 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 26.0904 43.6793 28.1059 43.0844 30M4.9156 30H43.0844",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;